export interface DiffSegment {
  type: 'same' | 'add' | 'del'
  text: string
}

export function wordDiff(before: string, after: string): DiffSegment[] {
  const tokenize = (s: string) => s.split(/(\s+)/).filter((t) => t.length > 0)
  const a = tokenize(before)
  const b = tokenize(after)
  const m = a.length
  const n = b.length

  const dp: number[][] = Array.from({ length: m + 1 }, () => new Array<number>(n + 1).fill(0))
  for (let i = m - 1; i >= 0; i--) {
    for (let j = n - 1; j >= 0; j--) {
      dp[i][j] = a[i] === b[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1])
    }
  }

  const segments: DiffSegment[] = []
  const push = (type: DiffSegment['type'], text: string) => {
    const last = segments[segments.length - 1]
    if (last && last.type === type) last.text += text
    else segments.push({ type, text })
  }

  let i = 0
  let j = 0
  while (i < m && j < n) {
    if (a[i] === b[j]) {
      push('same', a[i])
      i++
      j++
    } else if (dp[i + 1][j] >= dp[i][j + 1]) {
      push('del', a[i])
      i++
    } else {
      push('add', b[j])
      j++
    }
  }
  while (i < m) {
    push('del', a[i])
    i++
  }
  while (j < n) {
    push('add', b[j])
    j++
  }

  return segments
}
